export default "__VITE_ASSET__DJaFRzaq__"